import styled from "styled-components";

export const PageContainer = styled.div`
  max-width: 100%;
  margin: 0 auto;
  padding: 20px;
  background: #f5f7fa;
  min-height: 100vh;

  @media (max-width: 768px) {
    padding: 15px;
  }
`;

export const Header = styled.div`
  background: white;
  border-radius: 12px;
  padding: 30px;
  margin-bottom: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const HeaderTop = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 25px;

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`;

export const HeaderIcon = styled.div`
  width: 60px;
  height: 60px;
  background: #203b34;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: white;

  @media (max-width: 768px) {
    width: 50px;
    height: 50px;
    font-size: 24px;
  }
`;

export const HeaderContent = styled.div`
  flex: 1;
`;

export const Title = styled.h1`
  color: #203b34;
  margin: 0;
  font-size: 28px;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

export const Subtitle = styled.p`
  color: #64748b;
  margin: 5px 0 0 0;
  font-size: 15px;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const NewSessionButton = styled.button`
  background: #f9ae17;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;

  &:hover {
    background: #e09d15;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(249, 174, 23, 0.3);
  }

  i {
    font-size: 16px;
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }
`;

export const SearchBar = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 12px 20px;

  i.fa-search {
    color: #64748b;
    font-size: 16px;
  }

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`;

export const SearchInput = styled.input`
  flex: 1;
  border: none;
  background: transparent;
  font-size: 15px;
  color: #1e293b;
  outline: none;

  &::placeholder {
    color: #94a3b8;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const FilterButton = styled.button`
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;

  &:hover {
    border-color: #cbd5e1;
    background: #f8fafc;
  }

  i {
    font-size: 14px;
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }
`;

export const SessionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
  gap: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const SessionCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: ${(props) =>
    props.$completed ? "2px solid #10b981" : "2px solid transparent"};

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
  }
`;

export const SessionHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 20px;
`;

export const CourseIcon = styled.div`
  width: 48px;
  height: 48px;
  background: ${(props) => (props.$completed ? "#e8e8e8" : "#f9ae17")};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: white;
  flex-shrink: 0;
`;

export const CourseTitle = styled.h3`
  flex: 1;
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.4;
`;

export const StatusBadge = styled.span`
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  background: ${(props) => {
    if (props.$status === "confirmed") return "#203b34";
    if (props.$status === "pending") return "#e0e7ff";
    return "#f1f5f9";
  }};
  color: ${(props) => {
    if (props.$status === "confirmed") return "white";
    if (props.$status === "pending") return "#4f46e5";
    return "#64748b";
  }};
`;

export const SessionBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const InfoIcon = styled.i`
  width: 32px;
  height: 32px;
  background: #fef3c7;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f59e0b;
  font-size: 14px;
  flex-shrink: 0;
  margin-top: 2px;

  &::before {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const InfoLabel = styled.div`
  font-size: 12px;
  color: #64748b;
  margin-bottom: 2px;
`;

export const InfoValue = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #1e293b;
`;

export const SessionFooter = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-top: 16px;
  border-top: 1px solid #f1f5f9;
  flex-wrap: wrap;

  &:first-of-type {
    border-top: none;
    padding-top: 0;
    margin-bottom: 16px;
  }
`;

export const FooterInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #64748b;

  i {
    color: #94a3b8;
    font-size: 14px;
  }

  strong {
    color: #1e293b;
    font-weight: 600;
  }

  &:not(:last-child) {
    margin-right: 12px;
  }
`;

export const ActionButton = styled.button`
  background: ${(props) => {
    if (props.$variant === "confirm") return "#10b981";
    if (props.$variant === "view") return "transparent";
    if (props.$variant === "edit") return "transparent";
    return "#f8fafc";
  }};
  color: ${(props) => {
    if (props.$variant === "confirm") return "white";
    if (props.$variant === "view") return "#64748b";
    if (props.$variant === "edit") return "#64748b";
    return "#64748b";
  }};
  border: ${(props) => {
    if (props.$variant === "confirm") return "none";
    return "1px solid #e2e8f0";
  }};
  border-radius: 6px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;

  &:hover {
    background: ${(props) => {
      if (props.$variant === "confirm") return "#059669";
      return "#f8fafc";
    }};
    border-color: ${(props) => {
      if (props.$variant === "confirm") return "transparent";
      return "#cbd5e1";
    }};
  }

  i {
    font-size: 12px;
  }
`;

export const MoreButton = styled.button`
  width: 32px;
  height: 32px;
  background: transparent;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  cursor: pointer;
  margin-left: auto;
  transition: all 0.2s ease;

  &:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
  }
`;

// Filter Accordion Styles
export const FilterAccordion = styled.div`
  margin-top: 20px;
  border-radius: 8px;
  /* overflow: hidden; */
  border: 1px solid #e2e8f0;
`;

export const AccordionItem = styled.div`
  background: white;
`;

export const AccordionHeader = styled.h2`
  margin: 0;
`;

export const AccordionButton = styled.button`
  width: 100%;
  background: #f8fafc;
  border: none;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 15px;
  font-weight: 600;
  color: #203b34;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;

  &:hover {
    background: #f1f5f9;
  }

  i {
    font-size: 14px;
    color: #f9ae17;
  }

  &[aria-expanded="true"] {
    background: #f1f5f9;
  }
`;

export const AccordionCollapse = styled.div``;

export const AccordionBody = styled.div`
  padding: 20px;
  background: white;
`;

export const FilterForm = styled.form`
  width: 100%;
`;

export const FilterRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 15px;
  }
`;

export const FilterCol = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FilterActions = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const FilterButtonPrimary = styled.button`
  background: #203b34;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;

  &:hover {
    background: #152820;
    transform: translateY(-1px);
  }

  i {
    font-size: 14px;
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }
`;

export const FilterButtonSecondary = styled.button`
  background: #f8fafc;
  color: #64748b;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;

  &:hover {
    background: #f1f5f9;
    border-color: #cbd5e1;
  }

  i {
    font-size: 14px;
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }
`;

// Pagination Styles
export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
  padding: 20px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 15px;
  }
`;

export const PaginationInfo = styled.div`
  color: #64748b;
  font-size: 14px;
`;

export const PaginationButtons = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  span {
    color: #94a3b8;
    padding: 0 8px;
  }
`;

export const PageButton = styled.button`
  min-width: 36px;
  height: 36px;
  background: ${(props) => (props.$active ? "#203b34" : "white")};
  color: ${(props) => (props.$active ? "white" : "#64748b")};
  border: 1px solid ${(props) => (props.$active ? "#203b34" : "#e2e8f0")};
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover:not(:disabled) {
    background: ${(props) => (props.$active ? "#152820" : "#f8fafc")};
    border-color: ${(props) => (props.$active ? "#152820" : "#cbd5e1")};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  i {
    font-size: 12px;
  }
`;

export const ExportButton = styled.button`
  background: #203b34;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;

  &:hover {
    background: #152820;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 99, 33, 0.3);
  }

  i {
    font-size: 16px;
  }
`;
